import React, { useState } from 'react'
import { withFirebase } from '../../../services'

const NameModal = (props) => {

    const { firebase, userData, SweetAlert, setSweetAlert, setModalShow } = props

    const [username, setUsername] = useState(userData.name)
    const [isSaving, setIsSaving] = useState(false)
    const changeName = async (e) => {
        setIsSaving(true)
        e.preventDefault()
        const userId = firebase.auth.currentUser.uid
         const userEmail = firebase.auth.currentUser.email
        try {
            let dataTobeSaved = { ...userData }
            dataTobeSaved.name = username

            // 1️⃣ First check provider table
            const snap = await firebase.db
                .collection("healthCareProfessionals")
                .where("email", "==", userEmail)
                .where("isRequestPending", "==", false)
                .limit(1)
                .get();

            if (!snap.empty) {
                // ✅ Provider found → update healthcareprofessional
                const providerDoc = snap.docs[0];

                await firebase.db
                    .collection("healthCareProfessionals")
                    .doc(providerDoc.id)
                    .set(
                        {
                            name: username
                        },
                        { merge: true }
                    );
            }

            let ref = firebase.db.collection("users").doc(userId);

            await ref.set(dataTobeSaved, { merge: true }).then(() => {
                setIsSaving(false)
                setModalShow(false)
                setSweetAlert({ 
                    ...SweetAlert, 
                     show: true,
                     title: "Name Successfully Updated.", 
                     type: "success", 
                     onConfirm: () => {
                        setSweetAlert({...SweetAlert, show: false})
                         window.location.reload();
                     } })
            }).catch((error) => {
                setIsSaving(false)
                console.log(error)
            });


        } catch (error) {
            console.log(error)
            setIsSaving(false)
        }

    }


    return (
        <div className="name">
        <form onSubmit={changeName}>
            <div className="form-control">
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="inputText" required />
                <span className="floating-label">Name</span>
            </div>
            <input type="submit" id="email" name="email" value={isSaving ? "Saving..." : "Save Changes"} />
        </form>
    </div>
    )
}

export default withFirebase(NameModal)
